import React from 'react';
import DfbHeadline from '../ui-kit/dfb_headline';
import DfbIconButton from '../ui-kit/dfb_icon_button';
import Section from "./section"

const MShare = (props) => {
  let linkedin_link = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(props.url)}&title=${encodeURIComponent(props.title)}`
  let facebook_link = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(props.url)}&amp;t=${encodeURIComponent(props.title)}`
  let twitter_link = `http://twitter.com/intent/tweet?source=sharethiscom&amp;text=${encodeURIComponent(props.title)}&amp;url=${encodeURIComponent(props.url)}`

  return (
    <Section
      baseClass="m-Share"
      data={props}
    >
      <div className="m-Share-wrapper">
        <div className="m-Share-container">
          <div className="m-Share-content">
            <DfbHeadline headline={props.headline} headline_level="h4" add_class="m-Share-headline" />

            {/* <DfbButton
              icon_type="Share"
              tagName="button"
              add_class="m-Share-shareButton"
              title="Share"
            /> */}

            <DfbIconButton
              tagName="button"
              icon_type="Share"
              add_class="m-Share-shareButton"
              title="Share"
              label="Share"
              filled="true"
              big="true"
            />

            <div className="m-Share-socialLinkContainer">
              {/* <div className="m-Share-socialLink">
                <a className="m-Share-socialAnchor" href={linkedin_link}>
                  <DfbSymbol icon_type="Linkedin" />
                  <span className="u-SrOnly">Share this article to linkedin</span>
                </a>
              </div>

              <div className="m-Share-socialLink">
                <a className="m-Share-socialAnchor" href={facebook_link}>
                  <DfbSymbol icon_type="Facebook" />
                  <span className="u-SrOnly">Share this article to facebook</span>
                </a>
              </div>

              <div className="m-Share-socialLink">
                <a className="m-Share-socialAnchor" href={twitter_link}>
                  <DfbSymbol icon_type="Twitter" />
                  <span className="u-SrOnly">Share this article to twitter</span>
                </a>
              </div> */}

              <DfbIconButton
                tagName="a"
                link={linkedin_link}
                icon_type="Linkedin"
                add_class="m-Share-socialLink"
              />
              <DfbIconButton
                tagName="a"
                link={facebook_link}
                icon_type="Facebook"
                add_class="m-Share-socialLink"
              />
              <DfbIconButton
                tagName="a"
                link={twitter_link}
                icon_type="Twitter"
                add_class="m-Share-socialLink"
              />

            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MShare;
